export const RECEIVE_DATASOURCE = 'RECEIVE_DATASOURCE';
export const ERROR = 'ERROR';
